import React from 'react';

export interface IErrorBoundaryProps {
  children: React.ReactNode;
  fallback: ({ errors: [Error] }) => React.ReactNode;
}

export interface IErrorBoundaryState {
  hasError: boolean;
  error: Error;
}

/**
 * Error Boundary component
 *
 * see: https://reactjs.org/docs/error-boundaries.html
 */
export default class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  state = {
    hasError: false,
    error: null,
  };

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: !!error, error };
  }

  componentDidCatch(error: Error, errorInfo) {
    // log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback({ errors: [this.state.error] });
    }

    return this.props.children;
  }
}
